const config = {
    id: 21,
    name: "表单",
    type: 1,
    module_code: "form",
    icon: "icon-tms-form",
    font_icon: "&#xe606;",
    style_type: 1,
    link_type: 4,
    link_data: [],
    property_data: {
        button_color: "#ff4b55",
        button_name: "提交",
        success_text: "提交成功！",
        font_color: "#ffffff",
        show_fix: 1
    }
};
export default config;